export enum EButtonType {
  next = 'next',
  prev = 'previous',
}
